import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import {
  ChatRounded,
  PersonRounded,
  QuestionAnswerRounded,
  TrendingDownRounded,
  TrendingUpRounded,
} from "@mui/icons-material";

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: 16,
    backgroundColor: theme.palette.background.dark,
    borderRadius: 24,
  },
  card: {
    width: "100%",
    padding: 16,
    border: "1px solid #F3E5F5",
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    boxShadow: "0 0 12px 1px rgba(191, 191, 191, 0.16)",
  },
}));

function Usage({ usage }) {
  const {
    active_users,
    queries,
    avg_queries_per_user,
    change: {
      active_users_pct,
      avg_queries_per_user_pct,
      queries_pct,
      active_users_direction,
      avg_queries_per_user_direction,
      queries_direction,
    },
  } = usage;
  const { classes } = useStyles();
  return (
    <Box className={classes.container}>
      <Box px={2} mb={1.5}>
        <Typography variant="h6">Usage</Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item size={{ xs: 12, md: 4 }}>
          <Box className={classes.card}>
            <Box display={"flex"} alignItems={"center"} gap={1} mb={1}>
              <Box
                height={30}
                width={30}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                sx={{ background: "#F3E5F5", borderRadius: 1 }}>
                <ChatRounded sx={{ fontSize: 16, color: "#9C27B0" }} />
              </Box>
              <Typography variant="body2" color={"text.secondary"}>
                Total queries/week
              </Typography>
            </Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              gap={1}>
              <Typography variant="h4">{queries}</Typography>
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"flex-end"}>
                <Box display={"flex"} alignItems={"center"} gap={0.5}>
                  {queries_direction === "increase" ? (
                    <TrendingUpRounded
                      sx={{ fontSize: 16, color: "#1B5E20" }}
                    />
                  ) : (
                    <TrendingDownRounded
                      sx={{ fontSize: 16, color: "#B71C1C" }}
                    />
                  )}

                  <Typography
                    fontSize={13}
                    fontWeight={500}
                    sx={{
                      color:
                        queries_direction === "increase"
                          ? "#1B5E20"
                          : "#B71C1C",
                    }}>
                    {Math.round(queries_pct)}%
                  </Typography>
                </Box>
                <Typography variant="caption" color={"text.secondary"}>
                  WoW
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item size={{ xs: 12, md: 4 }}>
          <Box className={classes.card}>
            <Box display={"flex"} alignItems={"center"} gap={1} mb={1}>
              <Box
                height={30}
                width={30}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                sx={{ background: "#FCE4EC", borderRadius: 1 }}>
                <QuestionAnswerRounded
                  sx={{ fontSize: 16, color: "#C51162" }}
                />
              </Box>
              <Typography variant="body2" color={"text.secondary"}>
                Avg queries/user/week
              </Typography>
            </Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              gap={1}>
              <Typography variant="h4">{avg_queries_per_user}</Typography>
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"flex-end"}>
                <Box display={"flex"} alignItems={"center"} gap={0.5}>
                  {avg_queries_per_user_direction === "increase" ? (
                    <TrendingUpRounded
                      sx={{ fontSize: 16, color: "#1B5E20" }}
                    />
                  ) : (
                    <TrendingDownRounded
                      sx={{ fontSize: 16, color: "#B71C1C" }}
                    />
                  )}
                  <Typography
                    fontSize={13}
                    fontWeight={500}
                    sx={{
                      color:
                        avg_queries_per_user_direction === "increase"
                          ? "#1B5E20"
                          : "#B71C1C",
                    }}>
                    {Math.round(avg_queries_per_user_pct)}%
                  </Typography>
                </Box>
                <Typography variant="caption" color={"text.secondary"}>
                  WoW
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item size={{ xs: 12, md: 4 }}>
          <Box className={classes.card}>
            <Box display={"flex"} alignItems={"center"} gap={1} mb={1}>
              <Box
                height={30}
                width={30}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                sx={{ background: "#E0F2F1", borderRadius: 1 }}>
                <PersonRounded sx={{ fontSize: 16, color: "#009688" }} />
              </Box>
              <Typography variant="body2" color={"text.secondary"}>
                Active users this week
              </Typography>
            </Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              gap={1}>
              <Typography variant="h4">{active_users}</Typography>
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"flex-end"}>
                <Box display={"flex"} alignItems={"center"} gap={0.5}>
                  {active_users_direction === "increase" ? (
                    <TrendingUpRounded
                      sx={{ fontSize: 16, color: "#1B5E20" }}
                    />
                  ) : (
                    <TrendingDownRounded
                      sx={{ fontSize: 16, color: "#B71C1C" }}
                    />
                  )}
                  <Typography
                    fontSize={13}
                    fontWeight={500}
                    sx={{
                      color:
                        active_users_direction === "increase"
                          ? "#1B5E20"
                          : "#B71C1C",
                    }}>
                    {Math.round(active_users_pct)}%
                  </Typography>
                </Box>
                <Typography variant="caption" color={"text.secondary"}>
                  WoW
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Usage;
